/*
 * @Author: eric.liu
 * @Date: 2017-05-03 16:40:00
 * @Last Modified by: eric.liu
 * @Last Modified time: 2017-05-09 16:56:00
 */
export default class Utils {
    static getCookie(name) {
        let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
        let arr = document.cookie.match(reg);
        if (arr)
            return unescape(arr[2]);
        else
            return null;
    }

    static setCookie(name, value) {
        let Days = 1;
        let exp = new Date();
        exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
        document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString();
    }

    static delCookie(name) {
        let exp = new Date();
        exp.setTime(exp.getTime() - 1);
        let cval = global.getCookie(name);
        if (cval !== null)
            document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
    }

    static setStorage(key, data) {
        var sdata = {
            data: data
        };
        window.sessionStorage.setItem(key, JSON.stringify(sdata));
    }

    static getStorage(key) {
        var sdata = window.sessionStorage.getItem(key);
        if (!sdata) {
            return null;
        } else {
            return JSON.parse(sdata).data;
        }
    }

    static clone(obj) {
        let data = JSON.stringify({data:obj});
        return JSON.parse(data).data;
    }

    /**
     * 根据目标对象 获取数据;
     * @param target
     * @param Obj
     * @return {*}
     */
    static mapGetData(target, Obj) {
        if (target && Obj) {
            Object.keys(target).forEach((key) => {
                if (key in Obj) {
                    if (Array.isArray(target[key])) {
                        if (Array.isArray(Obj[key])) {
                            target[key] = Obj[key];
                        } else {
                            target[key] = [];
                        }
                    } else {
                        target[key] = Obj[key];
                    }
                }
            });
        }
        return target;
    }

    //获取从min到max之间的随机整数，包括min,max在内
    static genNumberArray = (start, end) => {
        var arr = [];
        for (start; start <= end; start++) {
            arr.push(start)
        }
        return arr;
    };

    static capitalize(string) {
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    }
}



// WEBPACK FOOTER //
// ./src/helpers/utils.js